import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import classnames from 'classnames';

import { Typography, Row } from 'antd';
import { DragOutlined } from '@ant-design/icons';
import ColumnDraggable from './ColumnDraggable';

import './DataColumns.less';

const DataColumns = (props) => {
  const {
    propertiesData,
    viewMode,
    entityType,
    dataColumns,
    draggingTaskId,
    toggleSelection,
    selectedPropertyIds,
    isMinimumRequirement,
    toggleSelectionInGroup,
    handleRemoveDataColumns,
  } = props;

  return (
    <Droppable
      droppableId={'data_columns'}
      isDropDisabled={
        draggingTaskId?.draggableId?.indexOf('_query') > -1 ? true : false
      }
    >
      {(provided, { isDraggingOver }) => (
        <div
          ref={provided.innerRef}
          className={classnames({
            'data-columns scroller-extend': true,
            'data-columns--dragging-over': isDraggingOver,
          })}
        >
          <div style={{ pointerEvents: viewMode ? 'none' : 'auto' }}>
            {dataColumns?.map((fieldName, index) => {
              const isSelected = selectedPropertyIds.includes(
                fieldName + '_column'
              );

              const isGhosting =
                isSelected &&
                Boolean(draggingTaskId) &&
                draggingTaskId?.draggableId !== fieldName + '_column';
              return (
                <ColumnDraggable
                  index={index}
                  propertiesData={propertiesData}
                  fieldName={fieldName}
                  entityType={entityType}
                  key={fieldName + '_column'}
                  isSelected={isSelected}
                  isGhosting={isGhosting}
                  toggleSelection={toggleSelection}
                  selectionCount={selectedPropertyIds.length}
                  isMinimumRequirement={isMinimumRequirement}
                  toggleSelectionInGroup={toggleSelectionInGroup}
                  handleRemoveDataColumns={handleRemoveDataColumns}
                />
              );
            })}
          </div>
          {dataColumns?.length === 0 && (
            <Row className='data-columns__none-data'>
              <DragOutlined className='data-columns__none-data-icon' />
              <Typography.Title level={5}>
                Drag Attributes to this area to{' '}
                {isMinimumRequirement ? 'Required Properties' : 'Data Columns'}
              </Typography.Title>
            </Row>
          )}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default React.memo(DataColumns);
